import createIcon from '../../createIcon';

/**
 * @component @name NoAccounts
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMTggMTAuOTRDMTUuMzggMTAuNSAxNS41IDEwLjAyIDE1LjUgOS41QzE1LjUgNy41NyAxMy45MyA2IDEyIDZDMTEuNDggNiAxMSA2LjEyIDEwLjU2IDYuMzJMMTUuMTggMTAuOTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMiAxNUM5LjY4IDE1IDcuNTUgMTUuOCA1Ljg2IDE3LjEyQzQuNyAxNS43MyA0IDEzLjk1IDQgMTJDNCAxMC4xNSA0LjYzIDguNDUgNS42OSA3LjFMOC41NSA5Ljk2QzguNzYgMTEuNTIgOS45OCAxMi43NSAxMS41NCAxMi45NUwxMy43NCAxNS4xNUMxMy4xNyAxNS4wNSAxMi41OSAxNSAxMiAxNVpNMTguMzEgMTYuOUw3LjEgNS42OUM4LjQ1IDQuNjMgMTAuMTUgNCAxMiA0QzE2LjQyIDQgMjAgNy41OCAyMCAxMkMyMCAxMy44NSAxOS4zNyAxNS41NCAxOC4zMSAxNi45WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoAccounts = createIcon('NoAccounts', [
  [
    'path',
    {
      d: 'M15.18 10.94C15.38 10.5 15.5 10.02 15.5 9.5C15.5 7.57 13.93 6 12 6C11.48 6 11 6.12 10.56 6.32L15.18 10.94Z',
      key: '1v3vx4',
    },
  ],
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12C4 10.15 4.63 8.45 5.69 7.1L8.55 9.96C8.76 11.52 9.98 12.75 11.54 12.95L13.74 15.15C13.17 15.05 12.59 15 12 15ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.54 18.31 16.9Z',
      key: '16r6i5',
    },
  ],
]);

export default NoAccounts;
